import React from 'react';
import PropTypes from 'prop-types';

// @constants
import {
    FUND,
    PENSIONPLAN,
    SHARES
} from 'constants/aggregator/subtypes';

// @components
import { AggregatorShareDetails } from 'components/aggregator/aggregatorDetails/aggregatorInvestmentDetails/aggregatorShareDetails/aggregatorShareDetails';
import { AggregatorPensionPlanDetails } from 'components/aggregator/aggregatorDetails/aggregatorInvestmentDetails/aggregatorPensionPlanDetails/aggregatorPensionPlanDetails';
import { AggregatorFundDetails } from 'components/aggregator/aggregatorDetails/aggregatorInvestmentDetails/aggregatorFundDetails/aggregatorFundDetails';

class AggregatorInvestmentDetails extends React.PureComponent {

    renderFunds(products, isTinkAggregator){
        return (
            <AggregatorFundDetails
                products={products}
                isTinkAggregator={isTinkAggregator}
            />
        );
    }

    renderPesionPlans(products, isTinkAggregator){
        return (
            <AggregatorPensionPlanDetails
                products={products}
                isTinkAggregator={isTinkAggregator}
            />
        );
    }

    renderShares(products, isTinkAggregator){
        return (
            <AggregatorShareDetails
                products={products}
                isTinkAggregator={isTinkAggregator}
            />
        );
    }

    render() {
        const { subtype, products, isTinkAggregator } = this.props;

        const mapItem = {
            [FUND]: this.renderFunds(products, isTinkAggregator),
            [PENSIONPLAN]: this.renderPesionPlans(products, isTinkAggregator),
            [SHARES]: this.renderShares(products, isTinkAggregator)
        };

        return (
            <div>
                {mapItem[subtype]}
            </div>
        );
    }
}

AggregatorInvestmentDetails.propTypes = {
    subtype: PropTypes.object,
    products: PropTypes.object,
    isTinkAggregator: PropTypes.bool
};

export { AggregatorInvestmentDetails };
